module.exports = __webpack_public_path__ + "img/documentation.250402ca.svg";